
import { Vue, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import ManifestModule from "@/store/modules/barcodeSystem/manifest";
import notifications from "@/lib/notifications";
import { ManifestListFilters } from "@/models/api/barcodeSystem/manifests/get";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";

const manifestModuleState = getModule(ManifestModule);
const barcodeSystemModuleState = getModule(BarcodeSystemModule);

@Component
export default class ManifestFilters extends Vue {
  localFilters: ManifestListFilters = null;

  get filters() {
    return manifestModuleState.filters;
  }

  created() {
    this.localFilters = JSON.parse(JSON.stringify(this.filters));
  }

  async submit() {
    manifestModuleState.setFilters(JSON.parse(JSON.stringify(this.localFilters)));
    manifestModuleState.setLoading(true);
    try {
      await manifestModuleState.getManifests({
        pageNumber: 1,
        pageSize: manifestModuleState.pageData.pageSize
      });
    } catch (ex) {
      notifications.error("Loading Manifests", "Failed to load barcode manifests", ex);
    }

    manifestModuleState.setLoading(false);
  }

  get currentFacilityCode(): string {
    return barcodeSystemModuleState.currentFacilityCode;
  }

  get loading(): boolean {
    return manifestModuleState.loading;
  }

  getBooleanOptions() {
    return [
      { label: "", value: null },
      { label: "Yes", value: true },
      { label: "No", value: false }
    ];
  }
}
